var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showErrorMessage)?_c('div',{staticClass:"text-center answer-audit"},[_vm._m(0),_c('div',{staticClass:"text-small text-theme-black-450 mt-1"},[_c('span',[_vm._v("未过审原因：")]),_c('span',[_vm._v(_vm._s(_vm.auditDescription))])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-theme-black-850 text-large leading-22"},[_c('span',[_vm._v("很遗憾，您提交答卷未过审")])])
}]

export { render, staticRenderFns }